import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const SocialResponsibiltiyAPI = (props) => {
  return axios.get(
    `${env.HOST}/tanggung-jawab-sosial${props}`,
    {
      headers
    }
  );
};
export default SocialResponsibiltiyAPI;
